if (customElements && !customElements.get('qty-radio-buttons')) {
  class QtyRadioButtons extends HTMLElement {
    constructor() {
      super();
      this.hiddenInput = this.querySelector('input[type="hidden"]');
      this.displayQtyLabel = this.querySelector('.js-qty__display');
      this.priceContainer = document.querySelector('[data-product-price]');
      this.basePrice = null;
      this.currencySymbol = null;
    }

    initializePriceData() {
      if (!this.priceContainer) return;

      const priceText = this.priceContainer.textContent.trim();
      const currencySymbolMatch = priceText.match(/^([^\d.,]+)/);
      const priceMatch = priceText.match(/[\d.,]+/);

      if (priceMatch) {
        this.currencySymbol = currencySymbolMatch ? currencySymbolMatch[1].trim() : '$';
        this.basePrice = parseFloat(priceMatch[0].replace(',', '.'));
      }
    }

    connectedCallback() {
      this.initializePriceData();
      this.updateValue();

      this.addEventListener('change', this.handleChange.bind(this));
    }

    handleChange(event) {
      if (event.target.type === 'radio' && event.target.checked) {
        this.updateValue();
      }
    }

    updateValue() {
      const checkedRadio = this.querySelector('input[type="radio"]:checked');

      if (checkedRadio && this.hiddenInput) {
        this.hiddenInput.value = checkedRadio.value;

        if (this.displayQtyLabel) {
          this.displayQtyLabel.textContent = checkedRadio.value;
        }

        this.updatePriceContent(checkedRadio.value);
      }
    }

    updatePriceContent(quantity) {
      if (!this.basePrice || !this.currencySymbol || !this.priceContainer) return;

      const newPrice = this.basePrice * parseInt(quantity);
      this.priceContainer.textContent = `${this.currencySymbol}${newPrice.toFixed(2)}`;
    }
  }

  customElements.define('qty-radio-buttons', QtyRadioButtons);
}